import { render } from "./auth-base-password-reset.vue?vue&type=template&id=655dcd06&scoped=true&ts=true"
import script from "./auth-base-password-reset.vue?vue&type=script&lang=ts"
export * from "./auth-base-password-reset.vue?vue&type=script&lang=ts"

import "./auth-base-password-reset.vue?vue&type=style&index=0&id=655dcd06&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655dcd06"]])

export default __exports__